import { curry, path, concat } from 'ramda'

const repeat = value => [value, value]

const contentfulSelector = curry((contentType, contentPath) =>
  path(concat([contentType], contentPath))
)

export { repeat, contentfulSelector }
